"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSectionFromRaw = parseSectionFromRaw;
const common_1 = require("../common/common");
const timeZones_1 = __importDefault(require("../common/timeZones"));
function parseSectionFromRaw(section) {
    return {
        id: section.ID,
        fromTime: (0, common_1.dateToKitchenTime)((0, common_1.fromOplusTime)(new Date(section.From)), timeZones_1.default.ASIA_TOKYO),
        toTime: (0, common_1.dateToKitchenTime)((0, common_1.fromOplusTime)(new Date(section.To)), timeZones_1.default.ASIA_TOKYO),
        purpose: section.Purpose,
        roleId: section.RoleID,
        color: section.Color,
        date: section.Date,
        type: section.Type,
        locked: section.Locked,
        rest: section.Rest,
        memo: section.Memo,
    };
}
